import { withStyles } from 'tss-react/mui';
import { PageSection } from '../pageSection';

export const StickyPanel = withStyles(PageSection, (theme) => ({
	paddingWrapper: {
		background: theme.palette.background.paper,
		paddingTop: 11,
		paddingBottom: 9,
		boxShadow: '0px 4px 16px rgb(0 0 0 / 15%)'
	},
	maxWidthWrapper: {

	}
}));
